import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "detail-line-items pt-4 pb-4 px-md-3" }
const _hoisted_2 = { class: "font-weight-bolder mb-2" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 pt-3 pr-md-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-2",
  style: {"font-size":"1rem"}
}, "Notes:", -1)
const _hoisted_6 = { style: {"font-size":"1rem","color":"#404040"} }
const _hoisted_7 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineItemPricing = _resolveComponent("LineItemPricing")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.lineItem.description), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.lineItem.note), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_LineItemPricing, { "line-item": _ctx.lineItem }, null, 8, ["line-item"])
      ])
    ])
  ]))
}